export default {
    GET_FAVORITE_COURSES: "GET_FAVORITE_COURSES",
    GET_FAVORITE_COURSES_ERROR: "GET_FAVORITE_COURSES_ERROR",
    GET_FAVORITE_COURSES_SUCCESS: "GET_FAVORITE_COURSES_SUCCESS",
    ADD_FAVORITE_COURSE: "ADD_FAVORITE_COURSE",
    ADD_FAVORITE_COURSE_ERROR: "ADD_FAVORITE_COURSE_ERROR",
    ADD_FAVORITE_COURSE_SUCCESS: "ADD_FAVORITE_COURSE_SUCCESS",
    CLEAR_ADDED_FAVORITE_COURSE: "CLEAR_ADDED_FAVORITE_COURSE"
};